import "../../exam/components/question/QuestionLegend/QuestionLegend.css";

const ExerciseQuestionLegend = ({ stats }) => {
  const counts = stats || {};

  return (
    <div className="question-legend">
      <div className="legend-title">Overview</div>

      <div className="legend-container">
        <div className="legend-item">
          <span className="legend-icon not-visited">
            {counts.notVisited ?? 0}
          </span>
          <span>Not Visited</span>
        </div>

        <div className="legend-item">
          <span className="legend-icon marked">{counts.marked ?? 0}</span>
          <span>Marked for Review</span>
        </div>

        <div className="legend-item">
          <span className="legend-icon answered">{counts.answered ?? 0}</span>
          <span>Answered</span>
        </div>

        <div className="legend-item">
          <span className="legend-icon answered-marked">
            {counts.answeredMarked ?? 0}
          </span>
          <span>Answered &amp; Marked for Review</span>
        </div>

        <div className="legend-item">
          <span className="legend-icon not-answered">
            {counts.notAnswered ?? 0}
          </span>
          <span>Not Answered</span>
        </div>

        <div className="legend-item">
          <span className="legend-icon current">{counts.current ?? 0}</span>
          <span>Current Question</span>
        </div>
      </div>
    </div>
  );
};

export default ExerciseQuestionLegend;
